module.exports = __webpack_public_path__ + "img/sold_house.3d859bd0.svg";